'use strict';

const Event = require('./../lib/events');

class TrapFocus {

    constructor() {
        this.tabKeyName = 'Tab';
        this.tabKeyCode = 9;
        this.focusableSelectors = 'a[href]:not([disabled]):not(.logo):not(.search-button):not(.show-on-focus), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])';

        Event.on('click', '[data-trigger="menu"]', (event) => {
            event.preventDefault();
            this.trapFocus(document.querySelector('[data-focusable-area]'));
        });
    }

    trapFocus(element) {
        const focusableEls = element.querySelectorAll(this.focusableSelectors);
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];

        element.addEventListener('keydown', (event) => {
            if (!(event.key === this.tabKeyName || event.keyCode === this.tabKeyCode)) {
                return;
            }

            if (event.shiftKey) {
                // Shift + tab
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    event.preventDefault();
                }
            } else {
                // Tab
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    event.preventDefault();
                }
            }
        });
    }

}

module.exports = TrapFocus;
